import { api } from "../config/api";

export const getNotificationPreferences = async () => {
  const response = await api.get("/notifications/preferences");
  return response.data;
};

export const updateNotificationPreferences = async (preferences) => {
  const response = await api.put("/notifications/preferences", preferences);
  return response.data;
};

export const sendTestNotification = async () => {
  const response = await api.post("/notifications/test");
  return response.data;
};
